
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface Profile {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  phone: string | null;
  city: string | null;
  state: string | null;
}

interface ContactsTableProps {
  contacts: Profile[];
}

export const ContactsTable = ({ contacts }: ContactsTableProps) => {
  const navigate = useNavigate();

  const formatPhoneNumber = (phone: string | null) => {
    if (!phone) return "N/A";
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length !== 10) return phone;
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  };

  return (
    <div>
      {contacts.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          No clients found
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow className="bg-[#F1F0FB] hover:bg-[#F1F0FB]">
              <TableHead className="text-[#1A1F2C] font-semibold">Name</TableHead>
              <TableHead className="text-[#1A1F2C] font-semibold">Email</TableHead>
              <TableHead className="hidden sm:table-cell text-[#1A1F2C] font-semibold">Phone</TableHead>
              <TableHead className="hidden md:table-cell text-[#1A1F2C] font-semibold">Location</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {contacts.map((contact) => (
              <TableRow 
                key={contact.id}
                className="cursor-pointer hover:bg-[#F1F0FB]/50 transition-colors"
                onClick={() => navigate(`/admin/contact/${contact.id}`)}
              >
                <TableCell className="font-medium text-[#1A1F2C]">
                  {contact.first_name || ''} {contact.last_name || ''}
                </TableCell>
                <TableCell className="text-[#8E9196]">
                  {contact.email || 'N/A'}
                </TableCell>
                <TableCell className="hidden sm:table-cell text-[#8E9196]">
                  {formatPhoneNumber(contact.phone)}
                </TableCell>
                <TableCell className="hidden md:table-cell text-[#8E9196]">
                  {contact.city && contact.state
                    ? `${contact.city}, ${contact.state}`
                    : contact.city || contact.state || "N/A"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};
